module.exports = __webpack_public_path__ + "static/media/aligned.71680865.png";